<app-form-element [control]="formControl" [id]="id" [label]="label" [required]="required" [twoColumns]="twoColumns">
  <p-toggleswitch [formControl]="formControl" [id]="id"></p-toggleswitch>
</app-form-element>
